import logo from 'assets/images/icons/letrus-logo.webp';
import styles from './LetrusLoader.module.scss';

function LetrusLoader() {
  return (
    <div className={styles.wrapper} data-testid="loader">
      <img src={logo} alt="Letrus" aria-label="carregando" />

      <span className={styles.bar1} />
    </div>
  );
}

export default LetrusLoader;
